import {
  Atom,
  BookOpen,
  Calculator,
  Dna,
  Beaker,
  Folder,
  Globe,
  Scroll
} from 'lucide-react';

const SUBJECT_COLOR_MAP = {
  mathematics: {
    textColor: '#155DFC',
    bgColor: '#eff6ff',
    iconBg: '#dbeafe',
    iconColor: '#155DFC',
    Icon: Calculator,
    emoji: '🧮'
  },
  math: {
    textColor: '#155DFC',
    bgColor: '#eff6ff',
    iconBg: '#dbeafe',
    iconColor: '#155DFC',
    Icon: Calculator,
    emoji: '🧮'
  },
  maths: {
    textColor: '#155DFC',
    bgColor: '#eff6ff',
    iconBg: '#dbeafe',
    iconColor: '#155DFC',
    Icon: Calculator,
    emoji: '🧮'
  },
  physics: {
    textColor: '#F54900',
    bgColor: '#fff7ed',
    iconBg: '#ffedd5',
    iconColor: '#F54900',
    Icon: Atom,
    emoji: '⚛️'
  },
  chemistry: {
    textColor: '#00A63E',
    bgColor: '#f0fdf4',
    iconBg: '#dcfce7',
    iconColor: '#00A63E',
    Icon: Beaker,
    emoji: '🧪'
  },
  biology: {
    textColor: '#0D9488',
    bgColor: '#f0fdfa',
    iconBg: '#ccfbf1',
    iconColor: '#0D9488',
    Icon: Dna,
    emoji: '🧬'
  },
  history: {
    textColor: '#9810FA',
    bgColor: '#faf5ff',
    iconBg: '#f3e8ff',
    iconColor: '#9810FA',
    Icon: Scroll,
    emoji: '📜'
  },
  english: {
    textColor: '#DC2626',
    bgColor: '#fef2f2',
    iconBg: '#fee2e2',
    iconColor: '#DC2626',
    Icon: BookOpen,
    emoji: '📖'
  },
  science: {
    textColor: '#0891B2',
    bgColor: '#ecfeff',
    iconBg: '#cffafe',
    iconColor: '#0891B2',
    Icon: Beaker,
    emoji: '🔬'
  },
  geography: {
    textColor: '#CA8A04',
    bgColor: '#fefce8',
    iconBg: '#fef08a',
    iconColor: '#CA8A04',
    Icon: Globe,
    emoji: '🌍'
  },
  hindi: {
    textColor: '#BE185D',
    bgColor: '#fdf2f8',
    iconBg: '#fce7f3',
    iconColor: '#BE185D',
    Icon: BookOpen,
    emoji: '📖'
  },
  sanskrit: {
    textColor: '#9333EA',
    bgColor: '#faf5ff',
    iconBg: '#f3e8ff',
    iconColor: '#9333EA',
    Icon: Scroll,
    emoji: '📜'
  },
  economics: {
    textColor: '#0369A1',
    bgColor: '#f0f9ff',
    iconBg: '#e0f2fe',
    iconColor: '#0369A1',
    Icon: BookOpen,
    emoji: '📈'
  },
  accountancy: {
    textColor: '#15803D',
    bgColor: '#f0fdf4',
    iconBg: '#dcfce7',
    iconColor: '#15803D',
    Icon: BookOpen,
    emoji: '📒'
  },
  accounts: {
    textColor: '#15803D',
    bgColor: '#f0fdf4',
    iconBg: '#dcfce7',
    iconColor: '#15803D',
    Icon: BookOpen,
    emoji: '📒'
  },
  'computer science': {
    textColor: '#4F46E5',
    bgColor: '#eef2ff',
    iconBg: '#e0e7ff',
    iconColor: '#4F46E5',
    Icon: BookOpen,
    emoji: '💻'
  },
  computers: {
    textColor: '#4F46E5',
    bgColor: '#eef2ff',
    iconBg: '#e0e7ff',
    iconColor: '#4F46E5',
    Icon: BookOpen,
    emoji: '💻'
  },
  others: {
    textColor: '#4A5565',
    bgColor: '#f9fafb',
    iconBg: '#e5e7eb',
    iconColor: '#4A5565',
    Icon: Folder,
    emoji: '📁'
  }
};

const FALLBACK_COLOR = {
  textColor: '#4A5565',
  bgColor: '#f9fafb',
  iconBg: '#e5e7eb',
  iconColor: '#4A5565',
  Icon: Folder,
  emoji: '📁'
};

export const getSubjectColor = (subject) => {
  if (!subject) return FALLBACK_COLOR;

  const normalized = String(subject).trim().toLowerCase();
  if (!normalized) return FALLBACK_COLOR;

  if (SUBJECT_COLOR_MAP[normalized]) {
    return SUBJECT_COLOR_MAP[normalized];
  }

  for (const key of Object.keys(SUBJECT_COLOR_MAP)) {
    if (normalized.includes(key) || key.includes(normalized)) {
      return SUBJECT_COLOR_MAP[key];
    }
  }

  return FALLBACK_COLOR;
};
